import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { BrandMark } from "./BrandMark";
import { LazyMap } from "./LazyMap";
import { EyebrowLabel } from "@/components/ui-ext/Badge";
import { siteConfig } from "@/config/site";
import whatsappAsset from "@/assets/whatsapp-icon.png.asset.json";

const GMB_URL = "https://maps.app.goo.gl/L67bz47dQgtJs4Ba8";



const SOCIALS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/optimizplus",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" className="w-5 h-5">
        <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.098 4.388 23.093 10.125 24v-8.437H7.078v-3.49h3.047V9.066c0-3.019 1.792-4.687 4.533-4.687 1.313 0 2.686.235 2.686.235v2.953H15.83c-1.49 0-1.956.925-1.956 1.875v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.093 24 18.098 24 12.073z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/optimize.plus/",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" className="w-5 h-5">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
      </svg>
    ),
  },
  {
    label: "X (Twitter)",
    href: "https://x.com/optimize_plus",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" className="w-5 h-5">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@OptimizePlus",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" className="w-5 h-5">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/optimizplus",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" className="w-5 h-5">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.852 3.37-1.852 3.601 0 4.267 2.37 4.267 5.455v6.288zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: "Yelp",
    href: "https://yelp.com/biz/optimize-plus-austin",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" className="w-5 h-5">
        <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm6.305 9.065c.396.162.65.604.59 1.03l-.61 4.26c-.08.56-.585.95-1.15.87-.55-.08-.93-.55-.88-1.09l.61-4.26c.06-.426.39-.76.81-.86.05-.01.1-.02.15-.02.13.01.26.04.37.09l.11.04zm-4.77 6.47c.16.37.04.81-.26 1.05l-3.54 2.88c-.45.36-1.09.3-1.45-.15-.36-.45-.3-1.09.15-1.45l3.54-2.88c.37-.3.87-.32 1.24-.06.14.1.26.23.32.39v.17zm-.88-10.27c.37.16.6.54.55.94l-.63 4.39c-.07.5-.52.86-1.02.82-.51-.04-.89-.46-.88-.97l.63-4.39c.05-.4.35-.72.74-.82.09-.02.18-.03.27-.03.12.01.23.04.34.09zm-6.53 6.02c.16-.39.55-.62.97-.58l4.38.5c.5.06.86.51.82 1.01-.04.51-.46.89-.97.88l-4.38-.5c-.4-.05-.73-.35-.83-.74-.02-.09-.03-.18-.03-.27.01-.11.04-.22.09-.32l-.05.02zm7.77-1.04c-.39.16-.83.04-1.07-.26L9.34 8.15c-.36-.45-.3-1.09.15-1.45.45-.36 1.09-.3 1.45.15l3.54 2.88c.3.37.32.87.06 1.24-.1.14-.23.26-.39.32l-.01.01z" />
      </svg>
    ),
  },
];

type FooterLink =
  | { label: string; to: "/services/" | "/locations/" | "/industries/" | "/portfolio/" | "/case-studies/" | "/about/" | "/contact/" | "/guides/" | "/blog/" | "/tools/" | "/glossary/" | "/results/" | "/resources/" | "/" }
  | { label: string; to: "/services/$slug/"; params: { slug: string } }
  | { label: string; to: "/seo-agency-{$slug}"; params: { slug: string } }
  | { label: string; to: "/industries/$slug/"; params: { slug: string } }
  | { label: string; to: "/portfolio/$slug/"; params: { slug: string } }
  | { label: string; to: "/case-studies/$slug/"; params: { slug: string } }
  | { label: string; to: "/blog/$slug/"; params: { slug: string } }
  | { label: string; to: "/guides/$slug/"; params: { slug: string } }
  | { label: string; to: "/glossary/$slug/"; params: { slug: string } }
  | { label: string; to: "/tools/$slug/"; params: { slug: string } }
  | { label: string; to: "/authors/$slug/"; params: { slug: string } }
  | { label: string; to: "/services/$slug/guides/"; params: { slug: string }; search?: { tag?: string; page?: number } }
  | { label: string; to: "/locations/austin/neighborhoods/$slug/"; params: { slug: string } }
  | { label: string; to: "/contact/"; search: { location: string; service: string } };

const COLS: { heading: string; items: FooterLink[] }[] = [
  {
    heading: "Services",
    items: [
      { label: "Technical SEO", to: "/services/$slug/", params: { slug: "technical-seo" } },
      { label: "On-Page & Content", to: "/services/$slug/", params: { slug: "content-strategy" } },
      { label: `Local SEO — ${siteConfig.contact.address.city}`, to: "/services/$slug/", params: { slug: "local-seo" } },
      { label: "Link Building & Digital PR", to: "/services/$slug/", params: { slug: "link-building" } },
      { label: "AI Search (AEO/GEO)", to: "/services/$slug/", params: { slug: "aeo-geo" } },
      { label: "Analytics & Reporting", to: "/services/$slug/", params: { slug: "analytics-reporting" } },
      { label: "All services", to: "/services/" },
    ],
  },
  {
    heading: `${siteConfig.contact.address.city} & Texas`,
    items: [
      { label: `SEO ${siteConfig.contact.address.city}, ${siteConfig.contact.address.state}`, to: "/seo-agency-{$slug}", params: { slug: siteConfig.contact.address.city.toLowerCase() } },
      { label: "SEO Round Rock", to: "/seo-agency-{$slug}", params: { slug: "round-rock" } },
      { label: "SEO Cedar Park", to: "/seo-agency-{$slug}", params: { slug: "cedar-park" } },
      { label: "SEO Georgetown", to: "/seo-agency-{$slug}", params: { slug: "georgetown" } },
      { label: "SEO San Antonio", to: "/seo-agency-{$slug}", params: { slug: "san-antonio" } },
      { label: "SEO Houston", to: "/seo-agency-{$slug}", params: { slug: "houston" } },
      { label: "All Texas locations", to: "/locations/" },
    ],
  },

  {
    heading: "Resources",
    items: [
      { label: "Pillar guides", to: "/guides/" },
      { label: "Field notes (blog)", to: "/blog/" },
      { label: "Free SEO tools", to: "/tools/" },
      { label: "SEO glossary", to: "/glossary/" },
      { label: "Live results", to: "/results/" },
      { label: "Resource center", to: "/resources/" },
    ],
  },
  {
    heading: "Company",
    items: [
      { label: "Industries we serve", to: "/industries/" },
      { label: "Portfolio", to: "/portfolio/" },
      { label: "Case studies", to: "/case-studies/" },
      { label: "About & the team", to: "/about/" },
      { label: "Contact", to: "/contact/", search: { location: "", service: "" } },
    ],
  },
];


// Shared focus-visible ring for keyboard users
const focusRing =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-sm";

type SubStatus = "idle" | "success" | "error";

export function SiteFooter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<SubStatus>("idle");
  const [errorMsg, setErrorMsg] = useState("");
  const subscribed = status === "success";

  return (
    <footer
      role="contentinfo"
      className="mt-24 md:mt-32 border-t border-border"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Optimize Plus site footer
      </h2>

      {/* Map + local context */}
      <section
        aria-labelledby="footer-map-heading"
        className="container-page py-12 md:py-16 grid gap-10 lg:grid-cols-[1.15fr_1fr] items-start border-b border-border"
      >
        <div className="order-2 lg:order-1">
          <LazyMap
            query={`${siteConfig.name}, ${siteConfig.contact.address.street}, ${siteConfig.contact.address.city}, ${siteConfig.contact.address.state} ${siteConfig.contact.address.zip}`}
            title={`${siteConfig.name}, ${siteConfig.contact.address.street}, ${siteConfig.contact.address.city}, ${siteConfig.contact.address.state} ${siteConfig.contact.address.zip}`}
            ariaLabel={`Google Map showing ${siteConfig.name} at ${siteConfig.contact.address.street}, ${siteConfig.contact.address.city}, ${siteConfig.contact.address.state} ${siteConfig.contact.address.zip}`}

          />

          <p className="mt-3 text-xs text-muted-foreground">
            {siteConfig.name}, {siteConfig.contact.address.street}, {siteConfig.contact.address.city}, {siteConfig.contact.address.state} {siteConfig.contact.address.zip} · 24/7 services available.{" "}
            <a
              href={GMB_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={`story-link ${focusRing}`}
            >
              View on Google Business Profile
            </a>
          </p>
        </div>

        <div className="order-1 lg:order-2">
          <EyebrowLabel>Find us · {siteConfig.contact.address.city}, {siteConfig.contact.address.state}</EyebrowLabel>
          <h3
            id="footer-map-heading"
            className="mt-3 font-display text-2xl md:text-3xl leading-tight"
          >
            A {siteConfig.contact.address.city} studio serving {siteConfig.contact.address.state}, coast to coast.
          </h3>

          <p className="mt-3 text-sm text-muted-foreground leading-relaxed max-w-md">
            We work with founders and marketing leads across {siteConfig.contact.address.city} — from
            South {siteConfig.contact.address.city} to Round Rock, Cedar Park, San Antonio, Houston, and
            the Dallas–Fort Worth metroplex. Available 24/7 for urgent SEO and
            AI-search support.

          </p>

          <div className="mt-6 flex flex-wrap gap-4">
            <a
              href={`https://wa.me/${siteConfig.contact.whatsapp.number}?text=${encodeURIComponent(siteConfig.contact.whatsapp.message)}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Chat with ${siteConfig.name} on WhatsApp at ${siteConfig.contact.whatsapp.display}`}
              className={`group inline-flex items-center gap-2.5 transition-all hover:-translate-y-0.5 active:scale-95 ${focusRing}`}
            >
              <img 
                src={whatsappAsset.url} 
                alt=""
                className="w-10 h-10 transition-transform group-hover:scale-110 drop-shadow-[0_4px_8px_rgba(37,211,102,0.3)]"
              />
              <span className="font-bold text-foreground">Message Us on WhatsApp</span>
            </a>
            <a
              href={`tel:+${siteConfig.contact.phoneNumeric}`}
              aria-label={`Call ${siteConfig.name} at ${siteConfig.contact.phone}`}

              className={`inline-flex items-center gap-2.5 rounded-full border border-border bg-background px-6 py-3 text-sm font-bold text-foreground shadow-sm transition-all hover:-translate-y-0.5 hover:bg-accent hover:shadow-md active:scale-95 ${focusRing}`}
            >
              <svg 
                aria-hidden="true" 
                focusable="false" 
                width="18" 
                height="18" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              {siteConfig.contact.phone}

            </a>
          </div>

        </div>
      </section>

      {/* Local trust strip */}
      <div className="container-page py-10 grid gap-6 md:grid-cols-3 border-b border-border">
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground">
            Headquarters
          </div>
          <address className="not-italic mt-2 text-sm leading-relaxed text-foreground/90">
            {siteConfig.name}<br />
            {siteConfig.contact.address.street}<br />
            {siteConfig.contact.address.city}, {siteConfig.contact.address.state} {siteConfig.contact.address.zip}<br />

            United States
          </address>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground">
            Contact
          </div>
          <ul className="mt-2 space-y-1.5 text-sm">
            <li>
              <a
                href={`mailto:${siteConfig.contact.email}`}
                className={`story-link ${focusRing}`}
              >
                {siteConfig.contact.email}

              </a>
            </li>
            <li>
              <a href={`tel:+${siteConfig.contact.phoneNumeric}`} className={`story-link ${focusRing}`}>
                {siteConfig.contact.phone}
              </a>
            </li>

            <li className="text-muted-foreground">24/7 services available</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground">
            Trust & expertise
          </div>
          <ul className="mt-2 space-y-1.5 text-sm text-foreground/90">
            <li>10+ years of hands-on SEO experience</li>
            <li>Google Search Console verified reporting</li>
            <li>Real client data · no black-box vendors</li>
          </ul>
        </div>
      </div>

      {/* Main link grid */}
      <div className="container-page py-20 md:py-28 grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr_1.2fr]">
        <div className="lg:col-span-1 md:col-span-2">
          <Link
            to="/"
            aria-label={`${siteConfig.name} — home`}

            className={`inline-flex ${focusRing}`}
          >
            <BrandMark variant="mark" size={96} className="md:hidden" />
            <BrandMark variant="mark" size={128} className="hidden md:block" />
          </Link>
          <p className="mt-5 text-sm text-muted-foreground max-w-sm leading-relaxed">
            {siteConfig.name} is an {siteConfig.tagline} helping
            local businesses and B2B teams earn measurable organic growth from
            Google, Google Business Profile, and the new generation of AI
            answer engines.

          </p>

        </div>

        {COLS.map((col, colIdx) => {
          const navId = `footer-nav-${colIdx}`;
          return (
            <nav key={col.heading} aria-labelledby={navId}>
              <h3
                id={navId}
                className="text-xs uppercase tracking-widest text-muted-foreground"
              >
                {col.heading}
              </h3>
              <ul className="mt-4 space-y-2.5 text-sm">
                {col.items.map((it, i) => {
                  const to = it.to as any;
                  const params = "params" in it ? it.params : ({} as any);
                  const search = "search" in it ? it.search : ({} as any);
                  
                  return (
                    <li key={`${col.heading}-${i}`}>
                      <Link
                        to={to}
                        params={params}
                        search={{
                          ...search,
                        }}
                        className={`text-foreground/85 story-link ${focusRing}`}
                      >
                        {it.label}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>
          );
        })}

        <div className="md:col-span-2 lg:col-span-1">
          <EyebrowLabel>Growth briefing</EyebrowLabel>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
            One email a month for {siteConfig.contact.address.city} founders and marketing leads. Local
            SEO wins, AI-search shifts, and case teardowns. No fluff.
          </p>

          <form
            className="mt-5 flex flex-col sm:flex-row gap-2"
            aria-label="Subscribe to the Growth Briefing newsletter"
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              const value = email.trim();
              // Simple RFC-5322-lite email pattern; server would re-validate.
              const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
              if (!value) {
                setStatus("error");
                setErrorMsg("Please enter your email address.");
                return;
              }
              if (!emailRe.test(value)) {
                setStatus("error");
                setErrorMsg("That email doesn't look right — please check the format.");
                return;
              }
              setStatus("success");
              setErrorMsg("");
              setEmail("");
            }}
          >
            <label htmlFor="footer-email" className="sr-only">
              Email address
            </label>
            <input
              id="footer-email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status !== "idle") setStatus("idle");
              }}
              placeholder="you@company.com"
              aria-describedby="footer-email-help"
              aria-invalid={status === "error" || undefined}
              className={`flex-1 min-w-0 rounded-full bg-background border px-4 py-2.5 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background ${
                status === "error" ? "border-destructive" : "border-input"
              }`}
            />
            <button
              type="submit"
              disabled={subscribed}
              className={`shrink-0 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:brightness-105 disabled:opacity-70 ${focusRing}`}
            >
              {subscribed ? "✓ Subscribed" : "Subscribe"}
            </button>
          </form>
          <p
            id="footer-email-help"
            aria-live="polite"
            role="status"
            className={`mt-2 text-xs ${
              status === "error"
                ? "text-destructive"
                : subscribed
                  ? "text-primary"
                  : "text-muted-foreground"
            }`}
          >
            {status === "error"
              ? errorMsg
              : subscribed
                ? "Thanks — you're on the list. We've sent a confirmation email to complete your opt-in (double-check spam)."
                : "Double opt-in. We'll never share your email. Unsubscribe anytime."}
          </p>


          <nav aria-label="Social media" className="mt-5">
            <ul className="flex flex-wrap gap-2">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Follow Optimize Plus on ${s.label}`}
                    className={`inline-flex items-center justify-center w-10 h-10 rounded-full border border-border bg-background text-foreground/80 hover:text-foreground hover:bg-accent transition ${focusRing}`}
                  >
                    {s.icon}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      {/* Legal bar */}
      <div className="hairline">
        <div className="container-page py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Optimize Plus · Austin, Texas. All rights reserved.</p>
          <nav aria-label="Legal and utility links">
            <ul className="flex flex-wrap gap-x-5 gap-y-1">
              <li>
                <Link to="/about/" className={`hover:text-foreground ${focusRing}`}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact/" search={{ location: "", service: "" }} className={`hover:text-foreground ${focusRing}`}>
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/resources/" className={`hover:text-foreground ${focusRing}`}>
                  Resources
                </Link>
              </li>
              <li>
                <a href="/sitemap.xml" className={`hover:text-foreground ${focusRing}`}>
                  Sitemap
                </a>
              </li>
              <li>
                <a
                  href="/llms.txt"
                  className={`hover:text-foreground ${focusRing}`}
                  title="Machine-readable site map for LLMs and answer engines"
                >
                  llms.txt
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
